import { render, staticRenderFns } from "./MilageIndex.vue?vue&type=template&id=0d127cc2&"
import script from "./MilageIndex.vue?vue&type=script&lang=js&"
export * from "./MilageIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports